import {AppUrls} from 'shared/config/model/urls';

import {MouseEvent, useCallback} from 'react';
import {generatePath, useNavigate} from 'react-router-dom';

import useOpenState from 'shared/lib/hooks/useOpenState';
import {getPortIncidentDurationSeconds, isPortIncidentOpen} from 'features/port/lib/portIncidentHelper';
import {getPortMonitorAddress} from 'features/port/lib/portMonitorHelper';

import IPortIncident from './PortIncident/IPortIncident';

export interface IUsePortIncidentRow {
    isOpen: boolean,
    name: string,
    address: string,
    durationSeconds: number,
    isModalOpen: boolean,
    closeModal: () => void,
    onRowClick: (_event: MouseEvent<HTMLTableRowElement>) => void,
    onButtonClick: (_event: MouseEvent<HTMLTableCellElement>) => void,
}

export const usePortIncidentRow = (
    item: IPortIncident,
    hideMonitor: boolean,
): IUsePortIncidentRow => {
    const modal = useOpenState();
    const navigate = useNavigate();
    const {open} = modal;

    const {uuid: portMonitorId, name, ip, port} = item.port_monitor;
    const address = getPortMonitorAddress(ip, port);

    const onRowClick = useCallback((event: MouseEvent<HTMLTableRowElement>) => {
        event.stopPropagation();
        open();
    }, [open]);

    const onButtonClick = useCallback((event: MouseEvent<HTMLTableCellElement>) => {
        event.stopPropagation();
        event.preventDefault();
        if (hideMonitor) {
            open();
        } else {
            navigate(generatePath(AppUrls.PORT_MONITOR_DETAILS, {portMonitorId}));
        }
    }, [hideMonitor, navigate, open, portMonitorId]);

    return {
        isOpen: isPortIncidentOpen(item),
        name,
        address,
        durationSeconds: getPortIncidentDurationSeconds(item),
        isModalOpen: modal.isOpen,
        closeModal: modal.close,
        onRowClick,
        onButtonClick,
    };
};

export default usePortIncidentRow;
